export const NBSOptions = [
  {
    value: '1.0106.90.00',
    label: 'Serviços de instalação não classificados em subposições anteriores',
  },
  {
    value: '1.0106.32.00',
    label:
      'Serviços de instalação de equipamentos de ventilação e de ar condicionado',
  },
  {
    value: '1.1404.43.00',
    label:
      'Serviços de análise e de exames técnicos de sistemas elétricos e mecânicos',
  },
  {
    value: '1.1803.29.00',
    label:
      'Serviços especializados de limpeza não classificados em subposições anteriores',
  },
  {
    value: '1.1806.59.00',
    label:
      'Serviços especializados de apoio a escritório não classificados em subposições anteriores',
  },
  {
    value: '1.2001',
    label:
      'Serviços de manutenção e reparação de produtos metálicos, maquinários e equipamentos',
  },
  {
    value: '1.2001.10.00',
    label:
      'Serviços de manutenção e reparação de produtos metálicos, exceto maquinários e equipamentos',
  },
  {
    value: '1.2001.20.00',
    label:
      'Serviços de manutenção e reparação de computadores e seus periféricos e de maquinário para escritório',
  },
  {
    value: '1.2001.3',
    label:
      'Serviços de manutenção e reparação de maquinários e equipamentos de transporte',
  },
  {
    value: '1.2001.31',
    label: 'Serviços de manutenção e reparação de veículos rodoviários',
  },
  {
    value: '1.2001.31.10',
    label:
      'Serviços de manutenção e reparação de veículos rodoviários motorizados',
  },
  {
    value: '1.2001.31.20',
    label:
      'Serviços de manutenção e reparação de veículos rodoviários não motorizados',
  },
  {
    value: '1.2001.32.00',
    label: 'Serviços de manutenção e reparação de veículos sobre trilhos',
  },
  {
    value: '1.2001.33.00',
    label: 'Serviços de manutenção e reparação de veículos aquaviários',
  },
  {
    value: '1.2001.34',
    label:
      'Serviços de manutenção e reparação de veículos de transporte aéreo e aeroespacial',
  },
  {
    value: '1.2001.34.10',
    label:
      'Serviços de manutenção e reparação de aeronaves, exceto de motores, turborreatores e turbopropulsores aeronáuticos',
  },
  {
    value: '1.2001.34.20',
    label:
      'Serviços de manutenção e reparação de motores, turborreatores e turbopropulsores aeronáuticos',
  },
  {
    value: '1.2001.34.30',
    label:
      'Serviços de manutenção e reparação de foguetes e equipamentos aeroespaciais',
  },
  {
    value: '1.2001.35.00',
    label: 'Serviços de manutenção e reparação de veículos militares',
  },
  {
    value: '1.2001.39.00',
    label:
      'Serviços de manutenção e reparação de maquinários e equipamentos de transporte não classificados em subposições anteriores',
  },
  {
    value: '1.2001.40.00',
    label:
      'Serviços de manutenção e reparação de plataformas, inclusive navios-plataforma, para extração de petróleo e gás',
  },
  {
    value: '1.2001.50.00',
    label:
      'Serviços de manutenção e reparação de maquinários e equipamentos de uso industrial',
  },
  {
    value: '1.2001.60.00',
    label:
      'Serviços de manutenção e reparação de maquinários e equipamentos de uso comercial',
  },
  {
    value: '1.2001.70.00',
    label:
      'Serviços de manutenção e reparação de equipamentos e aparelhos de telecomunicações',
  },
  {
    value: '1.2001.8',
    label:
      'Serviços de manutenção e reparação de outros maquinários e equipamentos',
  },
  {
    value: '1.2001.81.00',
    label:
      'Serviços de manutenção e reparação de aparelhos eletroeletrônicos domésticos',
  },
  {
    value: '1.2001.82.00',
    label:
      'Serviços de manutenção e reparação de instrumentos e equipamentos médicohospitalares, odontológicos, óticos e de precisão',
  },
  {
    value: '1.2001.83.00',
    label: 'Serviços de manutenção e reparação de equipamentos militares',
  },
  {
    value: '1.2001.89.00',
    label:
      'Serviços de manutenção e reparação de outros maquinários e equipamentos não classificados em subposições anteriores',
  },
  {
    value: '1.2002',
    label: 'Serviços de manutenção e reparação de outros bens de consumo',
  },
  {
    value: '1.2002.10.00',
    label:
      'Serviços de manutenção e reparação de produtos de couro, calçados, malas e bolsas',
  },
  {
    value: '1.2002.20.00',
    label: 'Serviços de manutenção e reparação de relógios e joias',
  },
  {
    value: '1.2002.30.00',
    label: 'Serviços de manutenção e reparação de móveis',
  },
  {
    value: '1.2002.40.00',
    label: 'Serviços de manutenção de roupas e outros produtos têxteis',
  },
  {
    value: '1.2002.90.00',
    label:
      'Serviços de manutenção e reparação de outros bens de consumo não classificados em subposições anteriores',
  },
  { value: '1.2003', label: 'Serviços de instalação, exceto os de construção' },
  {
    value: '1.2003.10.00',
    label:
      'Serviços de instalação de produtos metálicos, exceto maquinário e equipamentos',
  },
  {
    value: '1.2003.2',
    label: 'Serviços de instalação de maquinários, aparelhos e equipamentos',
  },
  {
    value: '1.2003.21',
    label:
      'Serviços de instalação de maquinários, aparelhos e equipamentos industriais',
  },
  {
    value: '1.2003.21.10',
    label: 'Serviços de montagem sob encomenda de turbinas industriais',
  },
  {
    value: '1.2003.21.90',
    label:
      'Serviços de instalação de maquinários, aparelhos e equipamentos industriais não classificados em itens anteriores',
  },
  {
    value: '1.2003.22.00',
    label:
      'Serviços de instalação de computadores e seus periféricos e maquinário de escritório',
  },
  {
    value: '1.2003.23.00',
    label:
      'Serviços de instalação de equipamentos e aparelhos de comunicação, incluindo de rádio e de televisão',
  },
  {
    value: '1.2003.24.00',
    label:
      'Serviços de instalação de maquinários, equipamentos, instrumentos e aparelhos médico-hospitalares, óticos e de precisão',
  },
  {
    value: '1.2003.25',
    label:
      'Serviços de instalação de sensores e sistemas de armas e de instalação de maquinários, aparelhos e equipamentos de emprego militar',
  },
  {
    value: '1.2003.25.10',
    label: 'Serviços de instalação de sensores e sistemas de armas',
  },
  {
    value: '1.2003.25.20',
    label:
      'Serviços de instalação de maquinários, aparelhos e equipamentos de emprego militar',
  },
  {
    value: '1.2003.26',
    label: 'Serviços de instalação de maquinários e equipamentos de transporte',
  },
  {
    value: '1.2003.26.10',
    label:
      'Serviços de montagem sob encomenda de motores, turborreatores e turbopropulsores aeronáuticos',
  },
  {
    value: '1.2003.26.90',
    label:
      'Serviços de instalação de maquinários e equipamentos de transporte não classificados em itens anteriores',
  },
  {
    value: '1.2003.29.00',
    label:
      'Serviços de instalação de maquinários, aparelhos e equipamentos não classificados em subposições anteriores',
  },
  {
    value: '1.0201.00.00',
    label: 'Serviços de agentes de distribuição de mercadorias',
  },

  {
    value: '1.0401',
    label: 'Serviços de transporte local de passageiros',
  },
  {
    value: '1.0401.1',
    label: 'Serviços de transporte terrestre local de passageiros',
  },
  {
    value: '1.0401.11',
    label: 'Serviços de transporte rodoviário local regular de passageiros',
  },
  {
    value: '1.0401.11.1',
    label:
      'Serviços de transporte rodoviário local regular de passageiros, exceto em áreas metropolitanas',
  },
  {
    value: '1.0401.11.11',
    label:
      'Serviços de transporte rodoviário local prestados exclusivamente por meio de ônibus',
  },
  {
    value: '1.0401.11.19',
    label:
      'Serviços de transporte rodoviário local regular de passageiros, exceto em áreas metropolitanas não classificados em subitens anteriores',
  },
  {
    value: '1.0401.11.20',
    label:
      'Serviços de transporte rodoviário local regular de passageiros, em áreas metropolitanas',
  },
  {
    value: '1.0401.12',
    label:
      'Serviços especiais de transporte rodoviário local regular de passageiros',
  },
  {
    value: '1.0401.12.10',
    label: 'Serviços de transporte escolar',
  },
  {
    value: '1.0401.12.20',
    label: 'Serviços de transporte para aeroportos (shuttle)',
  },
  {
    value: '1.0401.12.90',
    label:
      'Serviços especiais de transporte rodoviário local regular de passageiros não classificados em itens anteriores',
  },
  {
    value: '1.0401.13.00',
    label: 'Serviços de táxi',
  },
  {
    value: '1.0401.14.00',
    label: 'Serviços de carro com motorista, exceto táxi',
  },
  {
    value: '1.0401.15',
    label:
      'Serviços de transporte rodoviário local de passageiros por fretamento',
  },
  {
    value: '1.0401.15.10',
    label: 'Serviços de fretamento contínuo, local',
  },
  {
    value: '1.0401.15.20',
    label: 'Serviços de fretamento eventual ou turístico, local',
  },
  {
    value: '1.0401.16',
    label:
      'Serviços de transporte local de passageiros por veículos sobre trilhos',
  },
  {
    value: '1.0401.16.10',
    label: 'Serviços de transporte ferroviário local de passageiros',
  },
  {
    value: '1.0401.16.20',
    label: 'Serviços de transporte metroviário (metrô) local de passageiros',
  },
  {
    value: '1.0401.16.90',
    label:
      'Serviços de transporte local de passageiros por veículos sobre trilhos não classificados em itens anteriores',
  },
  {
    value: '1.0401.17',
    label:
      'Serviços de transporte terrestre para passeios turísticos (sightseeing)',
  },
  {
    value: '1.0401.17.10',
    label:
      'Serviços de transporte rodoviário para passeios turísticos (sightseeing)',
  },
  {
    value: '1.0401.17.20',
    label:
      'Serviços de transporte ferroviário para passeios turísticos (sightseeing)',
  },
  {
    value: '1.0401.17.90',
    label:
      'Serviços de transporte terrestre para passeios turísticos (sightseeing) não classificados em itens anteriores',
  },
  {
    value: '1.0401.19.00',
    label:
      'Serviços de transporte terrestre local de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0401.2',
    label: 'Serviços de transporte aquaviário local de passageiros',
  },
  {
    value: '1.0401.21',
    label:
      'Serviços de transporte aquaviário local de passageiros, por navegação interior',
  },
  {
    value: '1.0401.21.10',
    label:
      'Serviços de transporte aquaviário local de passageiros, por navegação interior, em embarcações para travessia',
  },
  {
    value: '1.0401.21.20',
    label:
      'Serviços de transporte aquaviário local de passageiros, por navegação interior, em embarcações para cruzeiros',
  },
  {
    value: '1.0401.21.90',
    label:
      'Serviços de transporte aquaviário local de passageiros, por navegação interior não classificados em itens anteriores',
  },
  {
    value: '1.0401.22.00',
    label:
      'Serviços de transporte aquaviário local de passageiros por fretamento',
  },
  {
    value: '1.0401.23.00',
    label:
      'Serviços de transporte aquaviário para passeios turísticos (sightseeing)',
  },
  {
    value: '1.0401.29.00',
    label:
      'Serviços de transporte aquaviário local de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0401.30.00',
    label: 'Serviços de transporte integrado local de passageiros',
  },
  {
    value: '1.0401.4',
    label: 'Serviços de transporte aéreo local de passageiros',
  },
  {
    value: '1.0401.41.00',
    label: 'Serviços de táxi aéreo local',
  },
  {
    value: '1.0401.42.00',
    label: 'Serviços de transporte aéreo local de passageiros por fretamento',
  },
  {
    value: '1.0401.43.00',
    label:
      'Serviços de transporte aéreo para passeios turísticos (sightseeing)',
  },
  {
    value: '1.0401.49.00',
    label:
      'Serviços de transporte aéreo local de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0401.90.00',
    label:
      'Serviços de transporte local de passageiros não classificados não classificados em subposições anteriores',
  },
  {
    value: '1.0402',
    label: 'Serviços de transporte nacional, exceto local, de passageiros',
  },
  {
    value: '1.0402.1',
    label:
      'Serviços de transporte terrestre nacional, exceto local, de passageiros',
  },
  {
    value: '1.0402.11',
    label:
      'Serviços de transporte rodoviário nacional, exceto local, regular de passageiros',
  },
  {
    value: '1.0402.11.10',
    label:
      'Serviços de transporte rodoviário nacional, exceto local, prestados exclusivamente por meio de ônibus',
  },
  {
    value: '1.0402.11.90',
    label:
      'Serviços de transporte rodoviário nacional, exceto local, de passageiros não classificados em subitens anteriores',
  },
  {
    value: '1.0402.12.00',
    label:
      'Serviços especiais de transporte rodoviário nacional, exceto local, regular de passageiros',
  },
  {
    value: '1.0402.13',
    label:
      'Serviços de transporte rodoviário nacional, exceto local, de passageiros, por fretamento',
  },
  {
    value: '1.0402.13.10',
    label: 'Serviços de fretamento contínuo, nacional, exceto local',
  },
  {
    value: '1.0402.13.20',
    label:
      'Serviços de fretamento eventual ou turístico, nacional, exceto local',
  },
  {
    value: '1.0402.14.00',
    label:
      'Serviços de transporte ferroviário nacional, exceto local, de passageiros',
  },
  {
    value: '1.0402.19.00',
    label:
      'Serviços de transporte terrestre nacional, exceto local, de passageiros não classificados não classificados em subposições anteriores',
  },
  {
    value: '1.0402.2',
    label:
      'Serviços de transporte aquaviário nacional, exceto local, de passageiros',
  },
  {
    value: '1.0402.21',
    label:
      'Serviços de transporte aquaviário nacional, exceto local, de passageiros, por navegação interior',
  },
  {
    value: '1.0402.21.10',
    label:
      'Serviços de transporte aquaviário de passageiros, por navegação interior, em embarcações para travessia',
  },
  {
    value: '1.0402.21.20',
    label:
      'Serviços de transporte aquaviário de passageiros, por navegação interior, em embarcações para cruzeiros',
  },
  {
    value: '1.0402.21.90',
    label:
      'Serviços de transporte aquaviário nacional, exceto local, de passageiros, por navegação interior não classificados em itens anteriores',
  },
  {
    value: '1.0402.22.00',
    label: 'Serviços de transporte aquaviário nacional costeiro de passageiros',
  },
  {
    value: '1.0402.23.00',
    label:
      'Serviços de transporte aquaviário nacional, exceto local, de passageiros por fretamento',
  },
  {
    value: '1.0402.29.00',
    label:
      'Serviços de transporte aquaviário nacional, exceto local, de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0402.3',
    label:
      'Serviços de transporte aéreo nacional, exceto local, de passageiros',
  },
  {
    value: '1.0402.31.00',
    label:
      'Serviços de transporte aéreo nacional, exceto local, regular de passageiros',
  },
  {
    value: '1.0402.32.00',
    label: 'Serviços de táxi aéreo nacional, exceto local',
  },
  {
    value: '1.0402.33.00',
    label:
      'Serviços de transporte aéreo nacional, exceto local, de passageiros, por fretamento',
  },
  {
    value: '1.0402.39.00',
    label:
      'Serviços de transporte aéreo nacional, exceto local, de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0402.90.00',
    label:
      'Serviços de transporte nacional, exceto local, de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0403',
    label: 'Serviços de transporte internacional de passageiros',
  },
  {
    value: '1.0403.1',
    label:
      'Serviços regulares de transporte terrestre internacional de passageiros',
  },
  {
    value: '1.0403.11',
    label:
      'Serviços de transporte rodoviário internacional regular de passageiros',
  },
  {
    value: '1.0403.11.10',
    label:
      'Serviços de transporte de passageiros prestados exclusivamente por meio de ônibus',
  },
  {
    value: '1.0403.11.90',
    label:
      'Serviços de transporte rodoviário internacional de passageiros não classificados em itens anteriores',
  },
  {
    value: '1.0403.12.00',
    label:
      'Serviços de transporte rodoviário internacional de passageiros por fretamento',
  },
  {
    value: '1.0403.13',
    label:
      'Serviços de transporte internacional de passageiros por veículos sobre trilhos',
  },
  {
    value: '1.0403.13.10',
    label: 'Serviços de transporte internacional ferroviário de passageiros',
  },
  {
    value: '1.0403.13.90',
    label:
      'Serviços de transporte internacional de passageiros por veículos sobre trilhos não classificados em itens anteriores',
  },
  {
    value: '1.0403.19.00',
    label:
      'Serviços de transporte terrestre internacional de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0403.2',
    label: 'Serviços de transporte aquaviário internacional de passageiros',
  },
  {
    value: '1.0403.21',
    label:
      'Serviços de transporte aquaviário internacional de passageiros, por navegação interior',
  },
  {
    value: '1.0403.21.10',
    label:
      'Serviços de transporte aquaviário internacional de passageiros, por navegação interior, em embarcações para travessia',
  },
  {
    value: '1.0403.21.20',
    label:
      'Serviços de transporte aquaviário internacional de passageiros, por navegação interior, em embarcações para cruzeiros',
  },
  {
    value: '1.0403.21.90',
    label:
      'Serviços de transporte aquaviário internacional de passageiros, por navegação interior não classificados em itens anteriores',
  },
  {
    value: '1.0403.22.00',
    label:
      'Serviços de transporte aquaviário internacional costeiro de passageiros',
  },
  {
    value: '1.0403.23.00',
    label:
      'Serviços de transporte aquaviário internacional transoceânico de passageiros',
  },
  {
    value: '1.0403.24.00',
    label:
      'Serviços de transporte aquaviário internacional de passageiros por fretamento',
  },
  {
    value: '1.0403.29.00',
    label:
      'Serviços de transporte aquaviário internacional de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0403.3',
    label: 'Serviços de transporte aéreo internacional de passageiros',
  },
  {
    value: '1.0403.31.00',
    label: 'Serviços de transporte aéreo internacional regular de passageiros',
  },
  {
    value: '1.0403.32.00',
    label: 'Serviços de táxi aéreo internacional',
  },
  {
    value: '1.0403.33.00',
    label:
      'Serviços de transporte aéreo internacional de passageiros por fretamento',
  },
  {
    value: '1.0403.39.00',
    label:
      'Serviços de transporte aéreo internacional de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0403.90.00',
    label:
      'Serviços de transporte internacional de passageiros não classificados em subposições anteriores',
  },
  {
    value: '1.0404',
    label: 'Locação de veículos de passageiros com operador',
  },
  {
    value: '1.0404.10.00',
    label: 'Locação de veículos rodoviários de passageiros com motorista',
  },
  {
    value: '1.0404.20.00',
    label: 'Locação de embarcações de passageiros com tripulação',
  },
  {
    value: '1.0404.30.00',
    label: 'Locação de aeronaves de passageiros com tripulação',
  },
  {
    value: '1.0405.00.00',
    label: 'Afretamento de embarcações de passageiros por tempo',
  },
  {
    value: '1.0501',
    label: 'Serviços de transporte terrestre de cargas',
  },
  {
    value: '1.0501.1',
    label: 'Serviços de transporte rodoviário de cargas',
  },
  {
    value: '1.0501.11',
    label: 'Serviços de transporte rodoviário de cargas a granel',
  },
  {
    value: '1.0501.11.10',
    label: 'Serviços de transporte rodoviário de cargas sólidas a granel',
  },
  {
    value: '1.0501.11.20',
    label:
      'Serviços de transporte rodoviário de cargas líquidas, ou liquefeitas, a granel',
  },
  {
    value: '1.0501.11.30',
    label: 'Serviços de transporte rodoviário de cargas gasosas a granel',
  },
  {
    value: '1.0501.12',
    label:
      'Serviços de transporte rodoviário de carga geral, exceto em contêineres',
  },
  {
    value: '1.0501.12.10',
    label: 'Serviços de transporte rodoviário de carga solta, não unitizada',
  },
  {
    value: '1.0501.12.20',
    label: 'Serviços de transporte rodoviário de carga unitizada',
  },
  {
    value: '1.0501.12.30',
    label:
      'Serviços de transporte rodoviário de carga frigorificada ou climatizada',
  },
  {
    value: '1.0501.13',
    label: 'Serviços de transporte rodoviário de cargas em contêineres',
  },
  {
    value: '1.0501.13.10',
    label:
      'Serviços de transporte rodoviário de cargas em contêineres frigorificados ou climatizados',
  },
  {
    value: '1.0501.13.20',
    label:
      'Serviços de transporte rodoviário de cargas em contêineres não frigorificados ou climatizados',
  },
  {
    value: '1.0501.14',
    label: 'Serviços de transporte rodoviário de cargas especiais',
  },
  {
    value: '1.0501.14.10',
    label: 'Serviços de transporte rodoviário de cargas vivas',
  },
  {
    value: '1.0501.14.20',
    label:
      'Serviços de transporte rodoviário de mudanças domésticas e de mobília e outros objetos de escritório',
  },
  {
    value: '1.0501.14.30',
    label: 'Serviços de transporte rodoviário de cargas de grande porte',
  },
  {
    value: '1.0501.14.40',
    label: 'Serviços de transporte rodoviário de veículos',
  },
  {
    value: '1.0501.14.5',
    label: 'Serviços de transporte rodoviário de produtos perigosos',
  },
  {
    value: '1.0501.14.51',
    label:
      'Serviços de transporte rodoviário de combustíveis, lubrificantes e GLP, inclusive apresentados em botijões metálicos',
  },
  {
    value: '1.0501.14.52',
    label:
      'Serviços de transporte rodoviário de produtos químicos perigosos, exceto lubrificantes e GLP',
  },
  {
    value: '1.0501.14.59',
    label:
      'Serviços de transporte rodoviário de produtos perigosos não classificados em subitens anteriores',
  },
  {
    value: '1.0501.15.00',
    label: 'Serviços de transporte rodoviário de cargas postais e malotes',
  },
  {
    value: '1.0501.19.00',
    label:
      'Serviços de transporte rodoviário de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0501.2',
    label: 'Serviços de transporte ferroviário de cargas',
  },
  {
    value: '1.0501.21',
    label: 'Serviços de transporte ferroviário de cargas a granel',
  },
  {
    value: '1.0501.21.10',
    label: 'Serviços de transporte ferroviário de cargas sólidas a granel',
  },
  {
    value: '1.0501.21.20',
    label:
      'Serviços de transporte ferroviário de cargas líquidas, ou liquefeitas, a granel',
  },
  {
    value: '1.0501.21.30',
    label: 'Serviços de transporte ferroviário de cargas gasosas a granel',
  },
  {
    value: '1.0501.22',
    label:
      'Serviços de transporte ferroviário de cargas geral, exceto em contêineres',
  },
  {
    value: '1.0501.22.10',
    label: 'Serviços de transporte ferroviário de carga solta, não unitizada',
  },
  {
    value: '1.0501.22.20',
    label: 'Serviços de transporte ferroviário de carga unitizada',
  },
  {
    value: '1.0501.22.30',
    label:
      'Serviços de transporte ferroviário de carga frigorificada ou climatizada',
  },
  {
    value: '1.0501.23',
    label: 'Serviços de transporte ferroviário de cargas em contêineres',
  },
  {
    value: '1.0501.23.10',
    label:
      'Serviços de transporte ferroviário de cargas em contêineres frigorificados ou climatizados',
  },
  {
    value: '1.0501.23.20',
    label:
      'Serviços de transporte ferroviário de cargas em contêineres não frigorificados ou climatizados',
  },
  {
    value: '1.0501.24',
    label: 'Serviços de transporte ferroviário de cargas especiais',
  },
  {
    value: '1.0501.24.10',
    label: 'Serviços de transporte ferroviário de cargas vivas',
  },
  {
    value: '1.0501.24.2',
    label: 'Serviços de transporte ferroviário de produtos perigosos',
  },
  {
    value: '1.0501.24.21',
    label:
      'Serviços de transporte ferroviário de combustíveis, lubrificantes e GLP, inclusive apresentados em botijões metálicos',
  },
  {
    value: '1.0501.24.22',
    label:
      'Serviços de transporte ferroviário de produtos químicos perigosos, exceto lubrificantes e GLP',
  },
  {
    value: '1.0501.24.29',
    label:
      'Serviços de transporte ferroviário de produtos perigosos não classificados em subposições anteriores',
  },
  {
    value: '1.0501.25.00',
    label: 'Serviços de transporte ferroviário de bens e valores',
  },
  {
    value: '1.0501.29.00',
    label:
      'Serviços de transporte ferroviário de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0501.3',
    label: 'Serviços de transporte de cargas por meio de dutos',
  },
  {
    value: '1.0501.31.00',
    label:
      'Serviços de transporte de petróleo, gás natural e combustível por meio de dutos',
  },
  {
    value: '1.0501.32.00',
    label: 'Serviços de transporte de minérios por meio de dutos',
  },
  {
    value: '1.0501.39.00',
    label:
      'Serviços de transporte de cargas por meio de dutos não classificados em subposições anteriores',
  },
  {
    value: '1.0502',
    label: 'Serviços de transporte aquaviário de cargas',
  },
  {
    value: '1.0502.1',
    label: 'Serviços de transporte aquaviário por navegação interior de cargas',
  },
  {
    value: '1.0502.11',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas a granel',
  },
  {
    value: '1.0502.11.10',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas sólidas, a granel',
  },
  {
    value: '1.0502.11.20',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas líquidas, ou liquefeitas, a granel',
  },
  {
    value: '1.0502.11.30',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas gasosas a granel',
  },
  {
    value: '1.0502.12',
    label:
      'Serviços de transporte aquaviário por navegação interior de carga geral, exceto em contêineres',
  },
  {
    value: '1.0502.12.10',
    label:
      'Serviços de transporte aquaviário por navegação interior de carga solta, não unitizada',
  },
  {
    value: '1.0502.12.20',
    label:
      'Serviços de transporte aquaviário por navegação interior de carga unitizada',
  },
  {
    value: '1.0502.12.30',
    label:
      'Serviços de transporte aquaviário por navegação interior de carga frigorificada ou climatizada',
  },
  {
    value: '1.0502.13',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas em contêineres',
  },
  {
    value: '1.0502.13.10',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas em contêineres frigorificados ou climatizados',
  },
  {
    value: '1.0502.13.20',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas em contêineres não frigorificados ou climatizados',
  },
  {
    value: '1.0502.14',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas especiais',
  },
  {
    value: '1.0502.14.10',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas vivas',
  },
  {
    value: '1.0502.14.20',
    label:
      'Serviços de transporte aquaviário por navegação interior de mudanças domésticas e de mobília e outros objetos de escritório',
  },
  {
    value: '1.0502.14.30',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas de grande porte',
  },
  {
    value: '1.0502.14.40',
    label:
      'Serviços de transporte aquaviário por navegação interior de veículos',
  },
  {
    value: '1.0502.14.5',
    label:
      'Serviços de transporte aquaviário por navegação interior de produtos perigosos',
  },
  {
    value: '1.0502.14.51',
    label:
      'Serviços de transporte aquaviário por navegação interior de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos',
  },
  {
    value: '1.0502.14.52',
    label:
      'Serviços de transporte aquaviário por navegação interior de produtos químicos perigosos, exceto lubrificantes e GLP',
  },
  {
    value: '1.0502.14.59',
    label:
      'Serviços de transporte aquaviário por navegação interior de produtos perigosos não classificados em subposições anteriores',
  },
  {
    value: '1.0502.14.90',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas especiais não classificados em subposições anteriores',
  },
  {
    value: '1.0502.19.00',
    label:
      'Serviços de transporte aquaviário por navegação interior de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0502.2',
    label: 'Serviços de transporte aquaviário costeiro de cargas',
  },
  {
    value: '1.0502.21',
    label: 'Serviços de transporte aquaviário costeiro de cargas a granel',
  },
  {
    value: '1.0502.21.10',
    label:
      'Serviços de transporte aquaviário costeiro de cargas sólidas a granel',
  },
  {
    value: '1.0502.21.20',
    label:
      'Serviços de transporte aquaviário costeiro de cargas líquidas ou liquefeitas, a granel',
  },
  {
    value: '1.0502.21.30',
    label:
      'Serviços de transporte aquaviário costeiro de cargas gasosas a granel',
  },
  {
    value: '1.0502.22',
    label:
      'Serviços de transporte aquaviário costeiro de cargas em geral, exceto em contêineres',
  },
  {
    value: '1.0502.22.10',
    label:
      'Serviços de transporte aquaviário costeiro de carga solta, não unitizada',
  },
  {
    value: '1.0502.22.20',
    label: 'Serviços de transporte aquaviário costeiro de carga unitizada',
  },
  {
    value: '1.0502.22.30',
    label:
      'Serviços de transporte aquaviário costeiro de carga frigorificada ou climatizada',
  },
  {
    value: '1.0502.23',
    label:
      'Serviços de transporte aquaviário costeiro de cargas em contêineres',
  },
  {
    value: '1.0502.23.10',
    label:
      'Serviços de transporte aquaviário costeiro de cargas em contêineres frigorificados ou climatizados',
  },
  {
    value: '1.0502.23.20',
    label:
      'Serviços de transporte aquaviário costeiro de cargas em contêineres não classificados em subposições anteriores',
  },
  {
    value: '1.0502.24',
    label: 'Serviços de transporte aquaviário costeiro de cargas especiais',
  },
  {
    value: '1.0502.24.10',
    label: 'Serviços de transporte aquaviário costeiro de cargas vivas',
  },
  {
    value: '1.0502.24.20',
    label:
      'Serviços de transporte aquaviário costeiro de mudanças domésticas e de mobília e outros objetos de escritório',
  },
  {
    value: '1.0502.24.30',
    label:
      'Serviços de transporte aquaviário costeiro de cargas de grande porte',
  },
  {
    value: '1.0502.24.40',
    label: 'Serviços de transporte aquaviário costeiro de veículos',
  },
  {
    value: '1.0502.24.5',
    label: 'Serviços de transporte aquaviário costeiro de produtos perigosos',
  },
  {
    value: '1.0502.24.51',
    label:
      'Serviços de transporte aquaviário costeiro de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos',
  },
  {
    value: '1.0502.24.52',
    label:
      'Serviços de transporte aquaviário costeiro de produtos químicos perigosos, exceto lubrificantes e GLP',
  },
  {
    value: '1.0502.24.59',
    label:
      'Serviços de transporte aquaviário costeiro de produtos perigosos não classificados em subposições anteriores',
  },
  {
    value: '1.0502.29.00',
    label:
      'Serviços de transportes aquaviário costeiro de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0502.3',
    label: 'Serviços de transporte aquaviário transoceânico de cargas',
  },
  {
    value: '1.0502.31',
    label: 'Serviços de transporte aquaviário transoceânico de cargas a granel',
  },
  {
    value: '1.0502.31.10',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas sólidas a granel',
  },
  {
    value: '1.0502.31.20',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas líquidas, ou liquefeitas, a granel',
  },
  {
    value: '1.0502.31.30',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas gasosas a granel',
  },
  {
    value: '1.0502.32',
    label:
      'Serviços de transporte aquaviário transoceânico de carga geral, exceto em contêineres',
  },
  {
    value: '1.0502.32.10',
    label:
      'Serviços de transporte aquaviário transoceânico de carga solta, não unitizada',
  },
  {
    value: '1.0502.32.20',
    label: 'Serviços de transporte aquaviário transoceânico de carga unitizada',
  },
  {
    value: '1.0502.32.30',
    label:
      'Serviços de transporte aquaviário transoceânico de carga frigorificada ou climatizada',
  },
  {
    value: '1.0502.33',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas em contêineres',
  },
  {
    value: '1.0502.33.10',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas em contêineres frigorificados ou climatizados',
  },
  {
    value: '1.0502.33.20',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas em contêineres não frigorificados ou climatizados',
  },
  {
    value: '1.0502.34',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas especiais',
  },
  {
    value: '1.0502.34.10',
    label: 'Serviços de transporte aquaviário transoceânico de cargas vivas',
  },
  {
    value: '1.0502.34.20',
    label:
      'Serviços de transporte aquaviário transoceânico de mudanças domésticas e de mobília e outros objetos de escritório',
  },
  {
    value: '1.0502.34.30',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas de grande porte',
  },
  {
    value: '1.0502.34.40',
    label: 'Serviços de transporte aquaviário transoceânico de veículos',
  },
  {
    value: '1.0502.34.5',
    label:
      'Serviços de transporte aquaviário transoceânico de produtos perigosos',
  },
  {
    value: '1.0502.34.51',
    label:
      'Serviços de transporte aquaviário transoceânico de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos',
  },
  {
    value: '1.0502.34.52',
    label:
      'Serviços de transporte aquaviário transoceânico de produtos químicos perigosos, exceto lubrificantes e GLP',
  },
  {
    value: '1.0502.34.59',
    label:
      'Serviços de transporte aquaviário transoceânico de produtos perigosos não classificados em subposições anteriores',
  },
  {
    value: '1.0502.39.00',
    label:
      'Serviços de transporte aquaviário transoceânico de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0503',
    label: 'Serviços de transporte aéreo de cargas',
  },
  {
    value: '1.0503.1',
    label: 'Serviços de transporte aéreo de cargas em contêineres',
  },
  {
    value: '1.0503.11.00',
    label:
      'Serviços de transporte aéreo de cargas em contêineres frigorificados ou climatizados',
  },
  {
    value: '1.0503.12.00',
    label:
      'Serviços de transporte aéreo de cargas em contêineres não frigorificados ou climatizados',
  },
  {
    value: '1.0503.2',
    label: 'Serviços de transporte aéreo de cargas especiais',
  },
  {
    value: '1.0503.21.00',
    label: 'Serviços de transporte aéreo de produtos perigosos',
  },
  {
    value: '1.0503.22.00',
    label: 'Serviços de transporte aéreo de cargas vivas',
  },
  {
    value: '1.0503.23.00',
    label: 'Serviços de transporte aéreo de máquinas e veículos',
  },
  {
    value: '1.0503.24.00',
    label: 'Serviços de transporte aéreo de produtos perecíveis',
  },
  {
    value: '1.0503.25.00',
    label: 'Serviços de transporte aéreo de cargas frágeis',
  },
  {
    value: '1.0503.26.00',
    label: 'Serviços de transporte aéreo de cargas controladas',
  },
  {
    value: '1.0503.27.00',
    label: 'Serviços de transporte aéreo de valores',
  },
  {
    value: '1.0503.28.00',
    label:
      'Serviços de transporte aéreo de cargas postais, remessas expressas e cargas congêneres',
  },
  {
    value: '1.0503.29.00',
    label:
      'Serviços de transporte aéreo de cargas especiais não classificados em subposições anteriores',
  },
  {
    value: '1.0503.90.00',
    label:
      'Serviços de transporte aéreo de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0504',
    label: 'Serviços de transporte multimodal de cargas',
  },
  {
    value: '1.0504.1',
    label: 'Serviços de transporte multimodal de cargas a granel',
  },
  {
    value: '1.0504.11.00',
    label: 'Serviços de transporte multimodal de cargas sólidas a granel',
  },
  {
    value: '1.0504.12.00',
    label:
      'Serviços de transporte multimodal de cargas líquidas, ou liquefeitas, a granel',
  },
  {
    value: '1.0504.13.00',
    label: 'Serviços de transporte multimodal de cargas gasosas a granel',
  },
  {
    value: '1.0504.2',
    label:
      'Serviços de transporte multimodal de carga geral, exceto em contêineres',
  },
  {
    value: '1.0504.21.00',
    label: 'Serviços de transporte multimodal de carga solta, não unitizada',
  },
  {
    value: '1.0504.22.00',
    label: 'Serviços de transporte multimodal de carga unitizada',
  },
  {
    value: '1.0504.23.00',
    label:
      'Serviços de transporte multimodal de carga frigorificada ou climatizada',
  },
  {
    value: '1.0504.3',
    label: 'Serviços de transporte multimodal de cargas em contêineres',
  },
  {
    value: '1.0504.31.00',
    label:
      'Serviços de transporte multimodal de cargas em contêineres frigorificados ou climatizados',
  },
  {
    value: '1.0504.32.00',
    label:
      'Serviços de transporte multimodal de cargas em contêineres não frigorificados ou climatizados',
  },
  {
    value: '1.0504.4',
    label: 'Serviços de transporte multimodal de cargas especiais',
  },
  {
    value: '1.0504.41.00',
    label: 'Serviços de transporte multimodal de cargas vivas',
  },
  {
    value: '1.0504.42.00',
    label:
      'Serviços de transporte multimodal de mudanças domésticas e de mobília e outros objetos de escritório',
  },
  {
    value: '1.0504.43.00',
    label: 'Serviços de transporte multimodal de cargas de grande porte',
  },
  {
    value: '1.0504.44.00',
    label: 'Serviços de transporte multimodal de veículos',
  },
  {
    value: '1.0504.45',
    label: 'Serviços de transporte multimodal de produtos perigosos',
  },
  {
    value: '1.0504.45.10',
    label:
      'Serviços de transporte multimodal de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos',
  },
  {
    value: '1.0504.45.20',
    label:
      'Serviços de transporte multimodal de produtos químicos perigosos, exceto lubrificantes e GLP',
  },
  {
    value: '1.0504.45.90',
    label:
      'Serviços de transporte multimodal de produtos perigosos não classificados em subposições anteriores',
  },
  {
    value: '1.0504.49.00',
    label:
      'Serviços de transporte multimodal de cargas especiais não classificados em subposições anteriores',
  },
  {
    value: '1.0504.90.00',
    label:
      'Serviços de transporte multimodal de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0505',
    label: 'Locação de veículos de cargas com operador',
  },
  {
    value: '1.0505.10.00',
    label: 'Locação de veículos rodoviários de carga com operador',
  },
  {
    value: '1.0505.20.00',
    label: 'Locação de embarcações de carga com tripulação',
  },
  {
    value: '1.0505.30.00',
    label: 'Locação de aeronaves de carga com tripulação',
  },
  {
    value: '1.0506.00.00',
    label: 'Afretamento de embarcações de carga por tempo',
  },
  { value: '1.0601', label: 'Serviços de manuseio de cargas' },
  { value: '1.0601.10.00', label: 'Serviços de manuseio de contêineres' },
  {
    value: '1.0601.90.00',
    label:
      'Serviços de manuseio de cargas não classificados em subposições anteriores',
  },
  { value: '1.0602', label: 'Serviços de armazenagem' },
  { value: '1.0602.10.00', label: 'Serviços de armazenagem frigorificada' },
  { value: '1.0602.2', label: 'Serviços de armazenagem de produtos perigosos' },
  {
    value: '1.0602.21.00',
    label: 'Serviços de armazenagem de petróleo e seus derivados',
  },
  {
    value: '1.0602.22.00',
    label:
      'Serviços de armazenagem de combustíveis, lubrificantes e GLP, inclusive apresentado em botijões metálicos',
  },
  {
    value: '1.0602.23.00',
    label: 'Serviços de armazenagem de produtos químicos perigosos',
  },
  {
    value: '1.0602.29.00',
    label:
      'Serviços de armazenagem de produtos perigosos não classificados em subposições anteriores',
  },
  {
    value: '1.0602.3',
    label:
      'Serviços de armazenagem de granéis sólidos, líquidos ou liquefeitos e gasosos',
  },
  {
    value: '1.0602.31.00',
    label: 'Serviços de armazenagem de granéis sólidos',
  },
  {
    value: '1.0602.32.00',
    label: 'Serviços de armazenagem de granéis líquidos ou liquefeitos',
  },
  {
    value: '1.0602.33.00',
    label: 'Serviços de armazenagem de granéis gasosos',
  },
  {
    value: '1.0602.90.00',
    label:
      'Serviços de armazenagem não classificados em subposições anteriores',
  },
  {
    value: '1.0603.00.00',
    label: 'Serviços de apoio ao transporte ferroviário',
  },
  { value: '1.0604', label: 'Serviços de apoio ao transporte rodoviário' },
  { value: '1.0604.10.00', label: 'Serviços de estações rodoviárias' },
  {
    value: '1.0604.2',
    label: 'Serviços de operação de rodovias, pontes e túneis',
  },
  { value: '1.0604.21.00', label: 'Serviços de operação de rodovias' },
  { value: '1.0604.22.00', label: 'Serviços de operação de pontes e túneis' },
  { value: '1.0604.30.00', label: 'Serviços de estacionamento' },
  {
    value: '1.0604.40.00',
    label: 'Serviços de reboque para veículos particulares e comerciais',
  },
  {
    value: '1.0604.90.00',
    label:
      'Serviços de apoio ao transporte rodoviário não classificados em subposições anteriores',
  },
  { value: '1.0605', label: 'Serviços de apoio ao transporte aquaviário' },
  {
    value: '1.0605.10.00',
    label: 'Serviços de operação de portos e canais, exceto manuseio de cargas',
  },
  { value: '1.0605.20.00', label: 'Serviços de praticagem e de atracação' },
  { value: '1.0605.30.00', label: 'Serviços de salvamento de embarcações' },
  { value: '1.0605.40.00', label: 'Serviços de navegação de apoio' },
  {
    value: '1.0605.90.00',
    label:
      'Serviços de apoio ao transporte aquaviário não classificados em subposições anteriores',
  },
  {
    value: '1.0606',
    label: 'Serviços de apoio ao transporte aéreo e aeroespacial',
  },
  { value: '1.0606.1', label: 'Serviços de apoio ao transporte aéreo' },
  {
    value: '1.0606.11.00',
    label: 'Serviços de operação aeroportuária, exceto manuseio de cargas',
  },
  { value: '1.0606.12.00', label: 'Serviços de controle de tráfego aéreo' },
  {
    value: '1.0606.19.00',
    label:
      'Serviços de apoio ao transporte aéreo não classificados em subposições anteriores',
  },
  {
    value: '1.0606.20.00',
    label: 'Serviços de apoio ao transporte aeroespacial',
  },
  {
    value: '1.0607.00.00',
    label: 'Serviços de agenciamento de transporte de cargas',
  },
  {
    value: '1.0608',
    label: 'Serviços de apoio ao transporte multimodal de cargas',
  },
  {
    value: '1.0608.10.00',
    label: 'Serviços de coleta e entrega de cargas no transporte multimodal',
  },
  {
    value: '1.0608.20.00',
    label:
      'Serviços de unitização ou desunitização de cargas no transporte multimodal',
  },
  {
    value: '1.0608.30.00',
    label: 'Serviços de movimentação de cargas no transporte multimodal',
  },
  {
    value: '1.0608.40.00',
    label:
      'Serviços de consolidação ou desconsolidação documental de cargas no transporte multimodal',
  },
  {
    value: '1.0608.90.00',
    label:
      'Serviços de apoio ao transporte multimodal de cargas não classificados em subposições anteriores',
  },
  {
    value: '1.0609.00.00',
    label:
      'Serviços de apoio aos transportes não classificados em posições anteriores',
  },
];
